export default __webpack_public_path__ + "static/hilton-deansgate-5cd22f949a15e1a44ca7f0f6b82ea4cc.png";